import { VEHICLE_IMAGE_SIZES, VehicleCard, type VehicleCardModel } from '@/features/vehicle';
import type { HeadingLevel } from '@/lib/utils/headingLevel';
import type { VehicleView } from './vehicleListing.constants';
import { VehicleListRow } from './VehicleListRow';

/** The first row is above the fold on every width: no lazy loading there. */
const EAGER_COUNT = 3;

type VehicleResultsProps = {
    vehicles: VehicleCardModel[];
    view: VehicleView;
    headingLevel: HeadingLevel;
};

export function VehicleResults({ vehicles, view, headingLevel }: VehicleResultsProps) {
    if (view === 'list') {
        return (
            <ul className="vehicle-list">
                {vehicles.map((vehicle, index) => (
                    <li key={vehicle.id}>
                        <VehicleListRow vehicle={vehicle} headingLevel={headingLevel} eager={index < EAGER_COUNT} />
                    </li>
                ))}
            </ul>
        );
    }

    return (
        <ul className="vehicle-grid">
            {vehicles.map((vehicle, index) => (
                <li key={vehicle.id}>
                    <VehicleCard
                        vehicle={vehicle}
                        sizes={VEHICLE_IMAGE_SIZES.grid}
                        headingLevel={headingLevel}
                        eager={index < EAGER_COUNT}
                    />
                </li>
            ))}
        </ul>
    );
}
